/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const tokenSlice = createSlice({
    name: 'tokenSlice',
    initialState: {
        token: null,
    },
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },
        destroyToken: (state) => {
            state.token = null;
            localStorage.clear();
        },
    },
});
export const { setToken, destroyToken } = tokenSlice.actions;

export default tokenSlice.reducer;
